module.exports = __webpack_public_path__ + "static/media/videos-home-icon.a859eece.svg";